var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filter.values
    ? _c(
        "FilterListBlock",
        {
          ref: "block",
          staticClass: "filter-list filter-list--checkbox",
          attrs: {
            name: _vm.filter.filter_name,
            "data-filter-name": _vm.name,
            "search-input-id": _vm.searchInputId,
            "is-open": _vm.isNotAllZeros,
            "is-label":
              _vm.filter.values.filter(function(el) {
                return el.product_count > 0
              }).length > 10
          },
          scopedSlots: _vm._u(
            [
              {
                key: "header",
                fn: function() {
                  return [
                    _vm.filter.values.filter(function(el) {
                      return el.product_count > 0
                    }).length > 10
                      ? _c("FilterListSearch", {
                          ref: "search",
                          staticClass: "filter-list__search",
                          style: [
                            _vm.filter.values.filter(function(el) {
                              return el.product_count > 0
                            }).length > 10
                              ? null
                              : { display: "none" }
                          ],
                          attrs: {
                            "search-input-id": _vm.searchInputId,
                            filter: _vm.filter.values,
                            name: _vm.filter.filter_name,
                            "filter-name": _vm.name
                          },
                          on: {
                            search: function($event) {
                              _vm.searchResults = $event
                            }
                          }
                        })
                      : _vm._e()
                  ]
                },
                proxy: true
              },
              {
                key: "footer",
                fn: function() {
                  return [
                    !_vm.searchResults.length && _vm.getMoreCount
                      ? _c(
                          "button",
                          {
                            staticClass: "filter-list__more btn--clear",
                            on: { click: _vm.toggleMore }
                          },
                          [
                            !_vm.showMore
                              ? _c(
                                  "span",
                                  {
                                    attrs: {
                                      "aria-label":
                                        "Zobacz więcej - " +
                                        _vm.filter.filter_name
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.i18n("More")) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "less",
                                    attrs: {
                                      "aria-label":
                                        "Zobacz mniej - " +
                                        _vm.filter.filter_name
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.i18n("Less")) +
                                        "\n            "
                                    )
                                  ]
                                ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "icon-arrow-indicators icon"
                            })
                          ]
                        )
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            ],
            null,
            false,
            2138346306
          )
        },
        [
          _vm._v(" "),
          _vm.filter && _vm.filter.values
            ? _c(
                "ul",
                _vm._l(_vm.getFilters, function(filterItem, index) {
                  return _c(
                    "li",
                    { key: _vm.name + "-" + index + "-" + filterItem.value },
                    [
                      filterItem.label
                        ? _c(
                            "UIInputCheckbox",
                            {
                              attrs: {
                                id:
                                  _vm.name +
                                  "-" +
                                  index +
                                  "-" +
                                  filterItem.value,
                                value: filterItem.value,
                                disabled: filterItem.product_count === 0,
                                checked:
                                  filterItem.active ||
                                  (_vm.filter.active &&
                                    _vm.filter.active === filterItem.value) ||
                                  _vm.isActiveFilter(
                                    _vm.name,
                                    filterItem.value
                                  ),
                                "aria-label":
                                  "zaznacz filtr: " +
                                  filterItem.label +
                                  " ilość produktów:" +
                                  filterItem.product_count,
                                "wrapper-class": "filter-list__control"
                              },
                              on: {
                                input: function(val) {
                                  return _vm.toggleFilter(
                                    val,
                                    _vm.name,
                                    filterItem.value,
                                    filterItem.label
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "filter-list__label" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(filterItem.label)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(_vm._s(filterItem.product_count))
                                  ])
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }